import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_itinerary_x_close",
  "use": "icon_itinerary_x_close-usage",
  "viewBox": "0 0 9.761 9.76",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.761 9.76\" id=\"icon_itinerary_x_close\"><defs><style>#icon_itinerary_x_close .a{fill:none;stroke:#9e9ca5;stroke-linecap:round;stroke-width:2px;}</style></defs><g transform=\"translate(-932.962 -177.332)\"><path class=\"a\" d=\"M-1151.624,185.746l6.932,6.932\" transform=\"translate(2086 -7)\" /><path class=\"a\" d=\"M-1144.692,185.746l-6.932,6.932\" transform=\"translate(2086 -7)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol